export default __webpack_public_path__ + "static/media/661.35abeed1.gif";